// exaustores.jsx
// Configuração dos exaustores

export const exaustoresConfig = [
  { 
    id: "exaustor01", 
    modulo: "3", 
    idx: "6", 
    descricao: "Exaustores Ímpares"
  },
  { 
    id: "exaustor02", 
    modulo: "3", 
    idx: "7", 
    descricao: "Exaustores Pares"
  }
];

// Função útil para obter informações de ON/OFF para cada exaustor
export const getExaustorOnOffValues = (exaustorId) => {
  const exaustor = exaustoresConfig.find(ex => ex.id === exaustorId || ex.descricao === exaustorId);
  if (!exaustor) {
    return null;
  }
  
  return {
    descricao: exaustor.descricao,
    onValue: JSON.stringify({ modulo: exaustor.modulo, idx: exaustor.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: exaustor.modulo, idx: exaustor.idx, status: "OFF" })
  };
};